export default {
  common: {
    email: 'E-mail',
    phone: 'Telefone',
    phoneNumber: 'Número de telefone',
    countrySelect: 'Escolha o país',
    countryUnmodifiedNote: 'O país não pode ser modificado após o registro',
    next: 'Próximo',
    back: 'Voltar',
    attention: 'Atenção',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    modify: 'Modificar',
    ignore: 'Ignorar',
    firstName: 'Primeiro nome',
    middleName: 'Nome do meio',
    lastName: 'Último nome',
    gender: 'Gênero',
    male: 'Masculino',
    female: 'Feminino',
    birthday: 'Aniversário',
    graphicCode: 'Código gráfico',
    emailCode: 'Código de verificação de e-mail',
    smsCode: 'Código SMS',
    smsVerificationCode: 'Código de verificação por SMS',
    bind: 'Vincular',
    send: 'Enviar',
    resend: 'Reenviar',
    address: 'Endereço',
    done: 'Concluído',
    systemMessage: 'Mensagem do sistema',
    setting: 'Configuração',
    submit: 'Enviar',
    language: 'Idioma',
    edit: 'Editar',
    delete: 'Excluir'
  },
  account: {
    account: 'Conta',
    nickname: 'Apelido',
    id: 'ID',
    basicInfo: 'Nível básico',
    placeholder: 'Digite',
    completed: 'Concluído',
    semiInfo: 'Semi-verificado',
    fullyInfo: 'Totalmente verificado',
    basicTab: 'Básico',
    advancedTab: 'Avançado',
    linkedAccount: 'Conta de retirada vinculada',
    accountSecurity: 'Conta e segurança da MetWallet',
    logout: 'Sair',
    semiToast: 'Conclua a verificação de nível básico',
    fullyToast: 'Conclua o nível básico \n e semi-verificado',
    quickLoginTitle: 'Login rápido',
    cancelQuickLogin: 'Tem certeza de que deseja desabilitar o Login rápido?'
  },
  accountSecurity: {
    title: 'Conta e segurança',
    payPwd: 'Senha de pagamento',
    loginPwd: 'Senha de login',
    changeEmail: 'Alterar e-mail',
    changePhone: 'Alterar número de telefone',
    changePayPwd: 'Alterar senha de pagamento',
    changeLoginPwd: 'Alterar senha de login',
    bindEmail: 'Vincular e-mail',
    bindEmailNote: 'Passe na verificação de e-mail para vinculá-lo',
    bindEmailPlaceholder: 'Digite o e-mail que deseja vincular',
    smsBindNote: 'Passe a verificação por SMS para vinculá-lo',
    bindPhone: 'Vincular número de telefone',
    smsAuthentication: 'Autenticação por SMS',
    emailAuthentication: 'Autenticação por e-mail',
    phoneVerificationNote: 'Passe pela verificação do número de telefone atual primeiro',
    bindPhonePlaceholder: 'Digite o número de telefone que deseja vincular',
    verificationWrongToast: 'Verifique seu código de verificação',
    phoneNumberEmptyToast: 'Preencha o número de telefone',
    verificationCodeEmptyToast: 'Preencha o código',
    wrongCodeToast: 'Código errado',
    changeNote: 'Passe na verificação para alterá-lo.',
    newEmailVerification: 'Nova verificação de e-mail',
    newEmailPlaceholder: 'Digite seu novo e-mail',
    change: 'Alterar',
    emailLowercaseToast: 'O e-mail deve estar em letras minúsculas.',
    newEmailEmptyToast: 'Preencha o novo e-mail',
    changeSuccessToast: 'Alterar com sucesso',
    phonePlaceholder: 'Digite o telefone',
    currentEmail: 'E-mail atual',
    passCurrentEmailVerificationFirst: 'Passar na verificação de e-mail atual primeiro',
    currentEmailVerification: 'Verificação de e-mail atual',
    smsVerification: 'Verificação por SMS',
    currentPhoneNumber: 'Número de telefone atual',
    currentPhoneVerification: 'Verificação de telefone atual',
    currentEmailAddress: 'Endereço de e-mail atual',
    phoneVerification: 'Verificação por telefone',
    enterVerificationCode: 'Insira o código de verificação',
    newPhoneNumber: 'Novo número de telefone',
    newEmail: 'Novo e-mail'
  },
  withdrawAccount: {
    selectAccountType: 'Selecionar tipo de conta',
    noBasicLevelVerificationDialog: 'Conclua a verificação de nível básico antes de vincular o método de saque.',
    bindNote: 'Preencha as informações corretas da conta, ou sua retirada será afetada.',
    bindBankAccount: 'Vincular conta bancária',
    bindMobileMoneyAccount: 'Vincular conta de dinheiro móvel',
    fieldEmptyToast: '{0} é obrigatório',
    fieldLengthToast: 'O {0} deve conter pelo menos {1} caracteres',
    bindBankRepeatToast: 'Não vincule a mesma conta bancária repetidamente!',
    accountName: 'Nome da conta',
    ifscCode: 'Código IFSC',
    accountEmptyToast: 'Conta é necessária',
    accountNameEmptyToast: 'Nome da conta é necessária',
    phoneEmptyToast: 'Telefone é necessário',
    emailEmptyToast: 'E-mail é necessário',
    ifscCodeEmptyToast: 'Código IFSC é necessário',
    ifscCodeLengthToast: 'O código IFSC deve ter 11 dígitos',
    bindIMPSRepeatToast: 'Não vincule a mesma conta IMPS repetidamente!',
    bindNote2:
      'Preencha seu endereço TRC-20 correto. Um endereço errado causará a perda do pagamento, pelo qual não nos responsabilizamos.',
    usdtAddress: 'Endereço USDT (TRC-20):',
    minimumLimit: 'Mínimo de retirada por transação: $ 10',
    usdtFee: 'Taxa: Sujeita às taxas efetivas',
    registerGcash: 'Se você não tiver uma conta Gcash, clique aqui para se registrar.',
    registerEpay: 'Se você não tiver uma conta Epay, clique aqui para se registrar.',
    bindThirdPartyTitle: 'Vincular {0} conta',
    wrongAccountToast: 'Conta errada',
    accountFormatToast: 'O formato da conta está incorreto',
    bindThirdPartyFailedToast: '{0} vinculação falhou',
    queryFailedToast: 'Consulta falhou.',
    editFailedToast: 'Falha na edição.',
    add: 'Adicionar',
    confirmEditDialog: 'Tem certeza de que deseja editar a conta {0}?',
    payPwdRequireDialog: 'Defina uma senha de pagamento de 6 dígitos antes de adicionar uma conta.',
    unbindFailedToast: 'Falha ao desvincular',
    cashOutSuccessNote: 'Hora estimada de chegada: dentro de 7 dias úteis',
    requestSubmitted: 'Solicitação de saque enviada',
    amountLimitToast1: 'O valor do saque deve ser ≥ $ 40,00',
    // eslint-disable-next-line no-template-curly-in-string
    amountLimitToast2: 'O valor do saque deve ser ≥ ${0},00',
    recommendAmountNote:
      'Dicas: Acumular o valor para $ {0} antes de sacar economizará efetivamente suas taxas de processamento.',
    amountNotEnoughToast: 'O valor do saque não é suficiente',
    exceedingLimitToast1: 'O valor do saque hoje atingiu o limite superior',
    exceedingLimitToast2:
      'O valor do saque hoje atingiu o limite superior. Você precisa concluir a certificação avançada para aumentar o limite?',
    restrictedCountriesPayPalAccountToast:
      'Não use uma conta do PayPal de países restritos, o que fará com que seu Arripay seja bloqueado',
    withdrawMinimumToast: 'Mínimo de saque por transação: $ 40',
    bankNotAvailableToast: 'Este banco não está mais disponível, vincule outros bancos.',
    usdtAccountInvalidToast: 'Esta conta USDT não pode sacar, use uma nova conta para saque.',
    noPayPwdToast: 'Defina uma senha de pagamento de 6 dígitos antes de sacar.',
    editBankAccount: 'Editar conta bancária',
    accountPlaceholder: 'Digite sua conta',
    trc20Placeholder: 'Digite o endereço TRC-20',
    accountRepeatToast: 'O mesmo que o atual.',
    unbindBankCardConfirmDialog: 'Tem certeza de que deseja desvincular o cartão bancário {0}?',
    unbindMobileMoneyAccountConfirmDialog: 'Tem certeza de que deseja desvincular a conta de dinheiro móvel {0}?',
    unbindAccountConfirmDialog: 'Tem certeza de que deseja desvincular a conta {0}?',
    availableBalance: 'Saldo disponível {0}',
    estimatedFee: 'Taxa estimada',
    submitFailToast: 'Falha no envio',
    disabledMethodToast: 'Este canal está temporariamente indisponível',
    channelUnavailableTitle: 'Canal indisponível',
    channelUnavailableNote: 'Este canal de saque está temporariamente indisponível. Tente outra forma.',
    channelUnavailableOk: 'OK',
    bankTransferUnavailableTitle: 'Transferência bancária indisponível',
    bankTransferUnavailableNote:
      'A transferência bancária não está disponível para a sua conta no momento. Use Epay para sacar.',
    channelMaintenanceTitle: 'Canal em manutenção',
    channelMaintenanceNote: 'Este canal de saque está em manutenção. Tente outra forma.',
    bankInfoUpdateTitle: 'Atualize seus dados bancários',
    bankInfoUpdateNote: 'Devido ao ajuste de política do banco, atualize seus dados bancários para continuar.',
    bindEpay: 'Vincular Epay',
    useEpay: 'Usar Epay',
    iMPSMaxLimitToast: 'O valor máximo de retirada para uma única transação por meio deste canal é de $ 260',
    linkedAccount: 'Conta adicionada',
    otherAccounts: 'Outras contas podem ser adicionadas',
    withdrawTo: 'Transferir para',
    withdrawAmount: 'Valor da transferência',
    withdrawable: 'Retirável',
    documentIdToast: 'O número de ID pode conter apenas números',
    noAvailableMethodNote: 'Nenhum método de saque disponível',
    recommended: 'Recomendado'
  },
  paymentCode: {
    changePayPwd: 'Alterar senha de pagamento',
    setPayPwd: 'Definir senha de pagamento',
    setPayPwdNote: 'Defina uma senha de pagamento de 6 dígitos',
    reenterPayPwdNote: 'Digite novamente',
    verificationNote: 'Passe na verificação para defini-la.',
    emailVerification: 'Verificação de e-mail',
    inconsistentPasswordToast: 'Senha inconsistente',
    payPwdNote: 'Insira a senha de pagamento',
    payPwdFormatToast: 'A senha de pagamento é um número de 6 dígitos',
    payPwdWrongToast: 'Senha de pagamento incorreta',
    payPwdVerificationFailToast: 'A verificação da senha de pagamento falhou!',
    successToast: 'Definir \n com sucesso'
  },
  authorize: {
    requirement:
      '{0} precisa adquirir as seguintes informações da sua MetWallet{1} para fornecer o serviço relacionado a você. Apelido, Avatar, Gênero etc.',
    authorize: 'Autorizar',
    switchAccount: 'Alterar conta',
    goToMetWallet: 'Ir para MetWallet',
    notMatchTips: 'A operação falhou. Você só pode habilitar o Login rápido com sua conta MetWallet vinculada'
  },
  basicLevel: {
    namePlaceholder: 'Sem símbolos, números',
    verification: 'Verificação',
    whatsAvailable: 'O que está disponível',
    cashOut: 'Saque',
    withdrawLimit: 'US$ 50 por dia',
    basicLevelNote:
      'Por favor, insira suas informações pessoais reais. Informações erradas podem causar falha na retirada.',
    fieldEmptyToast: 'Preencha todos os campos obrigatórios.',
    successToast: 'Salvo \n com sucesso',
    failToast: 'Falha no salvamento',
    confirmDialog:
      'Certifique-se de inserir suas informações pessoais reais. Informações erradas podem causar falha na retirada.',
    birthdayFormatToast: 'Formato incorreto do campo Aniversário',
    verificationCodeError: 'Erro no código de verificação',
    verificationCodeEmpty: 'Código de verificação vazio',
    noEmailCodeToast: 'Por favor, obtenha o código de verificação de e-mail',
    checkDialogTitle: 'Verifique suas informações',
    checkDialogContent:
      'Para retirar com sucesso, por favor, verifique suas informações. Informações erradas podem causar falha na retirada.',
    check: 'Verificar'
  },
  semiVerified: {
    uploadPhotoId: 'Carregar documento de identidade com foto',
    photoId: 'Digite novamente',
    resubmit: 'Reenviar',
    limit: 'US$ 5.000 por dia',
    uploading: 'Carregando...',
    notUploadProofToast: 'Carregue um comprovante de identidade'
  },
  fullyVerified: {
    frontOfId: 'Frente do documento',
    backOfId: 'Verso do documento',
    uploadIdFront: 'Enviar frente do documento',
    uploadIdBack: 'Enviar verso do documento',
    withdrawDailyHint: 'Preencha as informações para sacar > {0} por dia.',
    notUploadIdToast: 'Envie a frente e o verso do documento',
    proofTitle: 'COMPROVANTE DE RESIDÊNCIA',
    acceptableProof: 'UM COMPROVANTE DE RESIDÊNCIA ACEITÁVEL É:',
    acceptableProof1: 'Um extrato bancário.',
    acceptableProof2: 'Uma conta de serviços públicos (eletricidade, água, internet, etc.).',
    acceptableProof3:
      'Um documento emitido pelo governo (declaração de imposto de renda, certificado de residência, etc.).',
    unacceptableProof:
      'Não podemos aceitar o endereço no seu documento de identidade enviado como um comprovante de residência válido.',
    limit: '$ 10.000 por dia',
    notUploadToast: 'Faça upload de um comprovante de residência',
    incorrectFormatToast: 'Faça upload de uma imagem jpg/png/jpeg.'
  },
  loginAndRegister: {
    pwd: 'Senha',
    lastLogin: 'Último login',
    moreOptions: 'Mais opções',
    agreeCheckboxContent: 'Concordo com {0} e {1}',
    userAgreement: 'Contrato do usuário',
    privacyPolicy: 'Política de privacidade',
    notAgreeToast: 'Concordo com o Contrato do usuário e a Política de privacidade',
    forgotPassword: 'Esqueceu a senha',
    linkedMail: 'E-mail vinculado',
    verificationCode: 'Código de verificação',
    newPwd: 'Nova senha',
    repeatPwd: 'Repetir senha',
    confirmPwd: 'Confirmar senha',
    noLinkedEmailToast: 'Nenhum e-mail vinculado à sua conta',
    unregisteredToast: 'Este número não foi registrado',
    pwdFormatToast: 'O formato da senha está incorreto',
    resetSuccessToast: 'Redefinir \n com sucesso',
    pwdNotMatchToast: 'As senhas não correspondem duas vezes',
    emailFormatToast: 'Formato de e-mail incorreto',
    phoneNumberFormatToast: 'Formato de número de telefone incorreto',
    invalidAreaCodeToast: 'Código de área inválido',
    login: 'Entrar',
    pwdLogin: 'Entrar via senha',
    emailCodeLogin: 'Entrar via código de verificação de e-mail',
    smsLogin: 'Entrar via SMS',
    verifyEmail: 'Verificar e-mail',
    verifyPhone: 'Verificar telefone',
    accountDangerDialog:
      'Sua conta foi detectada como perigosa. Verifique novamente sua conta, caso contrário, ela não poderá continuar a ser usada.',
    sendEmailCodeDialog: 'Enviamos um código de verificação para seu e-mail {0}. Insira o código de verificação.',
    sendSmsCodeDialog: 'Enviamos um código de verificação para seu telefone {0}. Insira o código de verificação.',
    graphicCodeEmptyToast: 'Insira o código gráfico.',
    countryUnselectToast: 'Selecione seu país primeiro',
    unsupportedLoginTypeToast: 'Tipo de login não suportado',
    pwdWrongLimitOverDialog:
      'A senha errada foi inserida 3 vezes. Use o código de verificação por SMS para efetuar login.',
    loginFailedToast: 'Falha no login',
    signIn: 'Entrar',
    pwdPlaceholder: 'Digite a senha',
    pwdNote: 'Digite 8-16 caracteres com letras e números',
    reenterPwdPlaceholder: 'Digite a senha novamente',
    reenterPwdNote: 'Digite a senha novamente',
    createAccount: 'Criar conta',
    chooseCountryNote: 'Selecione o país',
    pwdInconsistentToast: 'Não é a mesma senha que você digitou anteriormente',
    createSuccessToast: 'Criar \n com sucesso',
    registerFailToast: 'Falha no registro',
    userNotExistToast: 'O usuário não existe',
    phoneIncorrectToast: 'Verifique seu telefone',
    userExistToast: 'O usuário já existe',
    countryCodeRepeatToast: 'Não digite o código do país repetidamente!',
    logoutDialog: 'Tem certeza de que deseja sair?',
    pwdRequirement: 'A senha deve ter pelo menos 8 a 16 caracteres com letras e números',
    signup: 'Inscrever-se',
    registerSuccessToast: 'Registrar \n com sucesso',
    oldPwdErrorToast: 'Verifique sua senha antiga'
  },
  checkUserInfo: {
    title: 'Central de gerenciamento',
    emptyInfoNote: 'Não há informações sobre a conta atual, verifique a conta MetWallet que você precisa verificar.',
    infoNote: 'Aqui estão suas informações de verificação.',
    lastSuccessWithdrawal: 'Último saque bem-sucedido',
    copyBtn: 'Copiar',
    successToast: 'Copiado com sucesso!',
    failToast: 'Falha ao copiar!'
  },
  country: {
    title: 'Selecione a região',
    popular: 'Popular'
  },
  documentDetails: {
    title: 'Detalhes do documento',
    contract: 'Contrato',
    goToSign: 'Vá para assiná-lo',
    download: 'Download',
    upload: 'Upload',
    fileTypeLimit: 'doc., pdf., xlsx., xls., png., jpg., jpeg., apenas documentos.',
    contentEmptyToast: 'Insira o conteúdo',
    placeOfBirth: 'Local de nascimento',
    occupation: 'Ocupação',
    fileForm: '(Formulário de arquivo)',
    proofOfAddress: 'Comprovante de endereço em inglês',
    residenceDoc: 'Documento de residência',
    textForm: '(Formulário de texto)',
    contractAgent: 'Agente do contrato',
    contractPayslip: 'Recibo de pagamento do contrato',
    uncompletedToast: 'Preencha-o para enviar',
    successToast: 'Enviar com sucesso',
    undefinedFileTypeToast: 'Tipo de upload de arquivo indefinido',
    uploadFailToast: 'Falha no upload'
  },
  filters: {
    amount: 'Quantidade',
    filter: 'Filtros',
    time: 'Hora',
    reset: 'Redefinir',
    timePickerTitle: 'Selecionar {0} Hora',
    start: 'Início',
    end: 'Fim',
    maximum: 'Máximo',
    minimum: 'Mínimo'
  },
  home: {
    balance: 'Saldo',
    transactions: 'Transações',
    availableBalance: 'Saldo disponível',
    noWithdrawalMethodToast: 'É necessário pelo menos um método de retirada.',
    linkAccount: 'Vincular conta',
    all: 'Todos',
    cashIn: 'Entrada de dinheiro',
    loading: 'carregando...',
    noMore: 'Não há mais transações',
    reload: 'Falha no carregamento, clique para recarregar',
    receivedFrom: 'Recebido de',
    transferredTo: 'Transferido para',
    fee: 'Taxa de transferência para',
    myEmail: 'Meu e-mail',
    myPhone: 'Meu telefone',
    invalidBasicLevelDialog:
      'Devido à inclusão de símbolos, espaços ou números no seu campo de nome, a retirada da conta não é possível. Preencha as informações básicas novamente (certifique-se de que o nome não inclua símbolos, espaços ou números e, se você não tiver família ou nome do meio, deixe em branco.)',
    lackLastNameDialog: 'Seu sobrenome não foi preenchido, o que dificultará sua retirada.',
    fillIn: 'Preencher',
    viewDetails: 'Ver detalhes',
    docReviewingDialogTitle: 'Aguarde a aprovação do documento.',
    docReviewingDialogContent:
      'Você enviou o documento, mas não pode usar o MetWallet antes que seu documento seja aprovado.<br>A equipe oficial o processará em breve, aguarde um pouco.',
    docPassedDialog: 'O documento que você enviou foi aprovado. <br>Você pode usar o MetWallet normalmente agora.',
    docUnqualifiedDialog: 'O documento que você enviou não é qualificado. <br>Envie um qualificado.',
    goToSubmit: 'Vá enviá-lo',
    uncompletedDialog: 'Você deve concluí-lo para usar o MetWallet normalmente',
    useMetWalletNormallyAfterPassed: 'Você pode usar o MetWallet normalmente após a aprovação do documento.',
    requireSemiVerifiedDialog:
      '{0}, para a exigência do banco, você tem que terminar a parte semiverificada em 48 horas para uma retirada bem-sucedida.',
    goToVerify: 'Vá verificar',
    emailInvalidDialog:
      '{0}, seu endereço de e-mail é o mesmo de outra pessoa. Para seguro de privacidade, insira seu próprio endereço de e-mail o mais rápido possível.',
    later: 'Mais tarde',
    transferRequireSemiVerifiedDialog: 'Conclua a verificação semiverificada antes da transferência.',
    modifyBtnText: 'Modificar Minhas Informações',
    unmodifiedTitle: 'Incapaz de modificar',
    unmodifiedContent: 'Você tem uma ordem de saque em processamento. As informações não podem ser modificadas agora.'
  },
  signing: {
    signature: 'Assinatura',
    date: 'Data',
    employeeName: 'Nome do funcionário',
    designation: 'Designação',
    month: 'Mês',
    year: 'Ano',
    earnings: 'Ganhos',
    deductions: 'Deduções',
    basic: 'Básico e DA (USD)',
    totalAddition: 'Adição total',
    totalDeduction: 'Dedução total',
    salary: 'Salário LÍQUIDO',
    refNo: 'Número de referência',
    paymentTransferDate: 'Data da transferência do pagamento',
    nameOfBank: 'Nome do banco',
    signatureOfEmployee: 'Assinatura do funcionário',
    director: 'Diretor',
    signNote: 'Assine seu nome',
    preview: 'Visualizar',
    clear: 'Limpar',
    save: 'Salvar',
    noSignatureToast: 'Você não pode salvar sem uma assinatura.',
    fieldEmptyToast: 'Preencha todas as informações.'
  },
  transactionDetail: {
    title: 'Detalhes da transação',
    status: 'Status',
    pending: 'Pendente',
    completed: 'Concluído',
    success: 'SUCESSO',
    failed: 'Falha',
    cancelled: 'Cancelado',
    onHold: 'Em espera',
    reason: 'Motivo do status',
    description: 'Descrição',
    creationDate: 'Data de criação',
    lastStatusDate: 'Data do último status',
    requestedAmount: 'Valor solicitado',
    receiveAmount: 'Valor recebido',
    transferAmount: 'Valor da transferência',
    amountToPay: 'Valor a pagar',
    transferFee: 'Taxa de transferência',
    processingFee: 'Taxa de processamento',
    method: 'Método',
    country: 'País',
    name: 'Nome',
    bankPendingText: 'Sob revisão bancária final',
    pendingText: 'Sob revisão {0}',
    chametSalary: 'Salário de Chamet',
    userSalary: 'Salário do usuário',
    comm: 'Com.',
    gemgalaSalary: 'Salário Gemgala'
  },
  transfer: {
    title: 'Para a conta MetWallet',
    noPayPwdDialog: 'Defina uma senha de pagamento de 6 dígitos antes da transferência.',
    records: 'Registros',
    cashInOut: 'Entrada de dinheiro {0}, Saque de dinheiro {1}',
    transfer: 'Transferência',
    fee: 'Taxa',
    remark: 'Observação',
    transferTo: 'Transferir para {0}',
    remarkPlaceholder: 'Adicionar observação de transferência (menos de 100 caracteres)',
    firstNameNote: 'Por favor, insira o primeiro nome dele/dela',
    sendingAmount: 'Valor enviado',
    receivingAmount: 'Valor recebido',
    transferNow: 'Transferir agora',
    noBalanceToast: 'O valor da transferência é maior que o valor do saldo.',
    amountTooLittleToast: 'O valor da transferência não pode ser menor que $ 10.'
  },
  bankData: {
    beneficiaryName: 'Nome do beneficiário',
    beneficiaryNamePlaceholder: 'Digite o nome',
    beneficiaryLastname: 'Sobrenome do beneficiário',
    beneficiaryLastnamePlaceholder: 'Digite o sobrenome',
    bankCode: 'Código do banco',
    bankCodePlaceholder: 'Selecione o código do banco',
    bankIFSCCode: 'Código IFSC do banco',
    bankIFSCCodePlaceholder: 'Digite o IFSC do banco',
    bankAccount: 'Conta bancária',
    bankAccountPlaceholder: 'Digite a conta bancária',
    email: 'E-mail',
    emailPlaceholder: 'Digite o e-mail',
    phoneNumber: 'Número de telefone',
    phoneNumberPlaceholder: 'Digite o número de telefone',
    address: 'Endereço',
    addressPlaceholder: 'Digite o endereço',
    city: 'Cidade',
    cityPlaceholder: 'Digite a cidade',
    state: 'Estado',
    statePlaceholder: 'Digite o estado',
    postCode: 'Código postal',
    postCodePlaceholder: 'Digite o código postal',
    documentId: 'ID do documento',
    documentIdPlaceholder: 'Digite o ID do documento',
    nationalId: 'National ID',
    nationalIdPlaceholder: 'Enter National ID',
    individualTaxId: 'Individual Tax ID',
    individualTaxIdPlaceholder: 'Enter Individual Tax ID',
    documentType: 'Tipo de documento',
    documentTypePlaceholder: 'Selecione o tipo de documento',
    accountType: 'Tipo de conta',
    accountTypePlaceholder: 'Selecione o tipo de conta',
    cpfcnpjPlaceholder: 'Digite CPFCNPJ',
    bankBranch: 'Agência bancária',
    bankBranchPlaceholder: 'Digite a agência bancária',
    ribOfBankAccount: 'RIB da conta bancária',
    bankName: 'Nome do banco',
    bankNamePlaceholder: 'Digite o nome do banco',
    bicCode: 'Código BIC',
    bicCodePlaceholder: 'Digite o código BIC',
    ibanPlaceholder: 'Digite o IBAN',
    bankSwift: 'Swift do banco',
    bankSwiftPlaceholder: 'Digite o Swift do banco',
    name: 'Nome',
    documentCountry: 'País do documento',
    documentCountryPlaceholder: 'Selecione o país do documento',
    issueDate: 'Data de emissão do documento',
    issueDatePlaceholder: 'Selecione a data de emissão',
    expireDate: 'Data de expiração do documento',
    expireDatePlaceholder: 'Selecione a data de expiração',
    bankBranchName: 'Nome da agência bancária',
    bankBranchNamePlaceholder: 'Digite o nome da agência',
    branchPlaceholder: 'Digite a agência',
    gender: 'Gênero',
    genderPlaceholder: 'Selecione o gênero',
    birthday: 'Aniversário',
    birthdayPlaceholder: 'Selecione Aniversário',
    phone: 'Telefone',
    bankAddress: 'Endereço do banco',
    bankAddressPlaceholder: 'Digite o endereço do banco',
    bankAccountName: 'Nome da conta bancária',
    bankAccountNamePlaceholder: 'Digite o nome da conta bancária',
    province: 'Província',
    provincePlaceholder: 'Digite a província',
    postalCode: 'Código postal',
    postalCodePlaceholder: 'Digite o código postal',
    savingsAccount: 'Conta poupança',
    abaRoutingNumber: 'Número de roteamento ABA',
    englandBankAccount: 'Conta bancária da Inglaterra',
    bankBranch2: 'bankBranch',
    bankBranch2Placeholder: 'Somente se o banco for Santander',
    paternalName: 'Nome paterno',
    paternalNamePlaceholder: 'Digite o nome paterno',
    passportIdNumber: 'Número de identificação do passaporte',
    bankNamePlaceholder2: 'Selecione o nome do banco',
    areaCode: 'Código de área',
    phoneNumberNoAreaCode: 'Número de telefone (sem código de área)',
    idType: 'Tipo de ID',
    idNo: 'Número de ID',
    idIssueDate: 'Data de emissão do ID',
    idExpireDate: 'Data de expiração do ID',
    ibanStyleToast: "Por favor, insira um conteúdo começando com 'SA' e com um comprimento de 24 caracteres."
  },
  rechargeAndTransfer: {
    transfer_limit_1: 'Você só pode transferir para Vendedores de Diamantes',
    search: 'Pesquisar',
    history: 'Usuários transferidos',
    confirm_content: 'Tem certeza de que deseja transferir {0} para {1}',
    success_content: '{0} foi transferido para {1}',
    purchase: 'Comprar',
    purchase_success: 'Você comprou {0} com sucesso',
    insufficient_balance: 'Saldo insuficiente',
    purchase_diamond: 'Comprar Diamantes',
    transfer_limit_2: 'O valor da transferência deve estar entre $ 10 e $ 30.000',
    no_data: 'Sem dados',
    invalid_number: 'Digite um número válido',
    under_limit: 'O valor da transferência não deve ser menor que $ 10',
    over_limit: 'O valor da transferência deve ser menor que $ 30.000'
  },
  redesign: {
    emailPlaceholder: 'Insira o endereço de e-mail',
    retrievePwd: 'Recuperar senha',
    resetPwd: 'Redefinir senha',
    newPwdPlaceholder: 'Insira a nova senha',
    reenterNewPwdPlaceholder: 'Reinsira a nova senha',
    reenterPayPwdPlaceholder: 'Por favor, insira a senha de pagamento novamente',
    sendToPhone: 'O código de verificação foi enviado para o seu telefone',
    sendToWhatsapp: 'O código de verificação foi enviado para o seu WhatsApp',
    sendToEmail: 'O código de verificação foi enviado para o seu e-mail',
    invalidCode: 'Código inválido',
    userId: 'ID do usuário',
    other: 'Outro',
    transactionRecord: 'Registro de transação',
    bankCardInfo: 'Conta de cartão bancário',
    withdrawInfo: 'Conta de saque',
    toFillIn: 'A ser preenchido',
    walletInfo: 'Informações da conta da carteira',
    toComplete: 'A ser preenchido',
    verifyGuide: 'Preencha as informações da conta da carteira para obter mais qualificações de retirada',
    verifyNote: 'Preencha as seguintes informações para obter qualificações de retirada diária de {0}',
    verifyCompletedNote: 'As informações foram concluídas para obter qualificações de retirada diária de {0}',
    continueBtnText: 'Continue preenchendo',
    submitInfo: 'Enviar informações',
    transferAmount: 'Valor da transferência',
    newEmailVerify: 'Nova verificação de e-mail',
    verifyCodePlaceholder: 'Insira o código de verificação',
    emailIncorrectToast: 'Por favor, insira o endereço de e-mail correto',
    newPhone: 'Novo número de telefone',
    accountAdded: 'Informações da conta adicionadas',
    accountToAdd: 'Outras contas podem ser adicionadas',
    edit: 'Editar',
    enterPayPwd: 'Insira a senha de pagamento',
    deleteBtnText: 'Excluir',
    transferTo: 'Transferir para',
    withdrawable: 'Retirável',
    goSet: 'Vá definir',
    goModify: 'Vá modificar'
  }
}



// WEBPACK FOOTER //
// ./src/configs/language/lang/pt.js